import React from 'react'
import PropTypes from 'prop-types'
import { useWindowWidth } from './MPGridUtils'

function MPGridGutter (props) {
  /*
    * Our 8 column grid uses 2 different Gutter sizes
    * The default is a width of 60px
    * The 3-column grid requires a gutter of 50px
    * Modify it to the 3-column grid context with the 'threeColumns' prop:
    * <MPGridGutter threeColumns />
  */

  let gutterStyle = {}

  if (useWindowWidth() >= 1060) {
    gutterStyle = props.threeColumns ? {
      height: '100%',
      width: 50
    } : {
      height: '100%',
      width: 60
    }
  } else {
    gutterStyle = {
      height: 30,
      width: '100%'
    }
  }

  return (
    <div style={gutterStyle} />
  )
}

MPGridGutter.propTypes = {
  threeColumns: PropTypes.bool
}

export default MPGridGutter
